import { transactionStatus } from "pages/transactions/constants";
import Avatar from "pages/_components/Avatar";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { bool, func, shape, string } from "prop-types";
import React, { useContext, useState } from "react";
import * as i18n from "util/i18n";
import * as config from "util/config";
import { useAccount } from "hooks/useAccounts";
import GridTable from "pages/_components/GridTable/GridTable";

const MepTransactionBody = (props) => {
    const { setShowMoreData, showMoreData, isDesktop } = props;
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, idTransactionStatus = "" } = transaction;

    const isFinished = idTransactionStatus === transactionStatus.FINISHED;
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const mepTransferNumber = transaction?.data?.mepTransferNumber || "";

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const {
        debitAccountLabel = props.debitAccountLabel,
        ownerName = props.ownerName,
        ownerCbu = props.ownerCbu,
        ownerCuit = props.ownerCuit,
        beneficiary = props.beneficiary,
        transferKind = props.transferKind,
        amount = props.amount,
        reasonCode = props.reasonCode,
        reference = props.reference,
    } = data;

    const { formatAccountBody } = useAccount();

    return (
        <div className="ticket__body newpayment">
            <div className="ticket-header-info ">
                <div className="beneficiary">
                    <div className="avatar-name">
                        <Avatar
                            user={{
                                userFullName: beneficiary?.recipientName || "",
                                defaultAvatarId: 0,
                                email: beneficiary?.emailRecipient,
                            }}
                        />
                    </div>
                    <div className="user-info align-items-center">
                        <div className="small">{i18n.get("echecks.beneficiary")}</div>
                        <div className="large">{`${beneficiary?.recipientName}`}</div>
                        <div className="small">{`${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`}</div>
                    </div>
                </div>
                <div>
                    <CustomData
                        dataClass={`amount tag tag-${isPending ? "warning" : "echeq-character"}`}
                        titleClass="text-right"
                        titleText="echecks.emit.amountField.label"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={amount.currency} quantity={amount.quantity} />}
                    />
                </div>
            </div>
            <div className="view-more-data-button" id="element-to-ignore">
                <div className="ticket__divider inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                />
            </div>
            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                <div className="ticket-body">
                    <div>
                        <GridTable>
                            <GridTable.Container className="ticket-gap" columnsTemplate={isDesktop && "repeat(2, 1fr)"}>
                                <GridTable.Data columnStart={1} rowStart={1}>
                                    <h2>{i18n.get("echecks.emissor", "Emisor")}</h2>
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={2} alignY="flex-start">
                                    <CustomData
                                        titleText="mep.debitAccount.label"
                                        titleTextType="I18N"
                                        valueText={debitAccountLabel}
                                    />
                                </GridTable.Data>

                                <GridTable.Data columnStart={1} rowStart={3}>
                                    <CustomData
                                        titleText="mep.holder.coporate.name"
                                        titleTextType="I18N"
                                        valueText={ownerName}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={4}>
                                    <CustomData
                                        titleText="mep.holder.cuit"
                                        titleTextType="I18N"
                                        valueText={ownerCuit}
                                    />
                                </GridTable.Data>

                                <GridTable.Data columnStart={2} rowStart={1}>
                                    <h2>{i18n.get("echecks.beneficiary")}</h2>
                                </GridTable.Data>
                                <GridTable.Data columnStart={2} rowStart={2}>
                                    <CustomData
                                        titleText="mep.creditAccount.label"
                                        titleTextType="I18N"
                                        valueText={formatAccountBody({
                                            accountNumber: beneficiary?.accountNumber,
                                            accountType: beneficiary?.productType.split(" ")[0],
                                            currency: beneficiary?.productType.split(" ")[1],
                                        })}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={2} rowStart={3}>
                                    <CustomData
                                        titleText="mep.holder.coporate.name"
                                        titleTextType="I18N"
                                        valueText={beneficiary?.recipientName}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={2} rowStart={4}>
                                    <CustomData
                                        titleText="mep.holder.cuit"
                                        titleTextType="I18N"
                                        valueText={beneficiary?.recipientDocumentNumber}
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                    </div>
                </div>
                <div className="ticket__divider divider_1 inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <div className="aditional-data">
                    <h2>{i18n.get("", "Datos adicionales")}</h2>
                    <CustomData
                        titleText="mep.holder.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`transfer.types.${transferKind}`}
                    />
                    <CustomData titleText="echecks.cbuIssuing" titleTextType="I18N" valueText={ownerCbu} />
                    <CustomData titleText="mep.reference.label" titleTextType="I18N" valueText={reference} />
                    <CustomData
                        titleText="mep.concept.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`mep.reasons.${reasonCode}`}
                    />
                    <CustomData
                        titleText="mep.fee.label"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                currency={config.get("mep.fee.currency", "ARS")}
                                quantity={config.getInteger("mep.fee", 0)}
                            />
                        }
                    />
                    {isFinished && (
                        <CustomData titleText="mep.number.label" titleTextType="I18N" valueText={mepTransferNumber} />
                    )}
                </div>
                <TransactionSign
                    isSmall
                    creationTime
                    hasVaucher
                    isDesktop={isDesktop}
                    noDate={isPending}
                    showMoreData={showMoreData}
                />
            </div>
        </div>
    );
};

MepTransactionBody.propTypes = {
    creditCbu: string,
    transferKind: string,
    reasonCode: string,
    reference: string,
    amount: shape({
        quantity: string,
        currency: string,
    }),
    beneficiary: shape({}),
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

MepTransactionBody.defaultProps = {
    creditCbu: "",
    transferKind: "",
    reasonCode: "",
    reference: "",
    amount: {
        quantity: "",
        currency: "",
    },
    beneficiary: null,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => {},
};

export default MepTransactionBody;
